module.exports = __webpack_public_path__ + "static/media/pic-7.0ecde32f.jpg";